module.exports = __webpack_public_path__ + "static/img/banner.d6247b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/module/active_423/images/banner.jpg
// module id = Sf7P
// module chunks = 92